import React from 'react';
import { ListLayout } from '../../../common/components/layout';
import ExhibitList from './list/exhibitList';

const Exhibits = () => {
  return <ListLayout list={<ExhibitList />} />;
};

export default Exhibits;
